// import { ErrorMessage, Field, Form, Formik } from "formik";
// import React, { useEffect, useRef, useState } from "react";
// import Select from "react-select";
// import { Helmet } from "react-helmet-async";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { EmojiIntialValues, EmojiValidationSchema } from "../../constant";
// import { useMutateEditEmoji } from "../../hooks/useApiHook";
// import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
// import { useQuery } from "@tanstack/react-query";
// import InputWithLabel from "../../../../Components/InputWithLabel";
// import { MdModeEditOutline } from "react-icons/md";
// import { GetSingleEmoji } from "../../../../Api/emoji";
// import selectImage from "../../../../assets/Images/selectImage.png";
// import { useMutateCreateImage } from "../../../Discover/hooks/useApiHook";

// const EditEmoji = () => {
//   const navigate = useNavigate();
//   const formRef = useRef();
//   const stateData = useLocation();
//   const fileInputRef = useRef(null);


//   const { id } = stateData?.state || "";



//   const addImageApi = useMutateCreateImage();
//   const editEmojiApi = useMutateEditEmoji();

//   const { data } = useQuery({
//     queryKey: ["get-single-emoji"],
//     queryFn: () => GetSingleEmoji(id),
//     throwOnError: (error) => {
//       ErrorToast(error?.response?.data?.message || "Server Error.");
//     },
//   });

//   useEffect(() => {
//     if (data) {
//       if (formRef?.current?.values) {
//         formRef?.current?.setValues({
//           name: data?.data?.name,
//           image: data?.data?.image_url,
//         });
//       }
//     }
//   }, [data]);

//   function getLastNameFromUrl(url) {
//     const parts = url.split("/");
//     return parts[parts.length - 1];
//   }

//   const handleSubmitEditCategory = (values) => {
//     const reqData = {
//       emojiId: id,
//       name: values?.name,
//       image: values?.image ? getLastNameFromUrl(values?.image) : "",
//     };

//     editEmojiApi.mutate(reqData, {
//       onSuccess: (response) => {
//         SuccessToast(response?.message || "Product Updated.");
//         navigate("/admin/emoji");
//       },
//       onError: (error) => {
//         ErrorToast(error?.response?.data?.message || "Server Error.");
//       },
//     });
//   };

//   return (
//     <>
//       <Helmet>
//         <title>OVE | Admin Edit Emoji</title>
//       </Helmet>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           <div className="page-header">
//             <div className="row">
//               <div className="col">
//                 <h3 className="page-title">Edit Emoji</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link
//                       to="/admin/dashboard"
//                       className="text-info text-decoration-underline"
//                     >
//                       Dashboard
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">
//                     <Link
//                       to="/admin/emoji"
//                       className="text-info text-decoration-underline"
//                     >
//                       Emoji
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item active">Edit Emoji</li>
//                 </ul>
//               </div>
//               <div className="col-auto">
//                 <Link to="/admin/emoji" className="btn btn-them-gray me-1">
//                   <i className="fas fa-angle-double-left" /> Back
//                 </Link>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-md-12">
//               <div className="card overflow-visible">
//                 <div className="card-body">
//                   <Formik
//                     initialValues={EmojiIntialValues}
//                     validationSchema={EmojiValidationSchema}
//                     validateOnChange
//                     onSubmit={handleSubmitEditCategory}
//                     innerRef={formRef}
//                   >
//                     {(formik) => {
//                       const {
//                         errors,
//                         touched,
//                         isSubmitting,
//                         setFieldValue,
//                         values,
//                       } = formik;
//                       return (
//                         <Form>
//                           <div className="row">
//                             <div className="col-md-6">
//                               <div className="user-information-container-div">
//                                 <div className="user-information-peta-container-div-one">
//                                   <div className="user-information-profile-section d-flex">
//                                   <img
//                                       src={values?.image ? values?.image : selectImage}
//                                       alt="image"
//                                       className="user-information-profile-image"
//                                       name="image"
//                                       onClick={() => fileInputRef.current.click()}
//                                     />
//                                     <input
//                                       ref={fileInputRef}
//                                       id="imageInput"
//                                       type="file"
//                                       multiple={false}
//                                       name="image"
//                                       accept="image/png, image/jpeg, image/jpg"
//                                       className="filetype d-none"
//                                       onChange={(event) => {
//                                         if (event.target.files && event.target.files[0]) {
//                                           event.preventDefault();

//                                           const formData = new FormData();
//                                           formData.append("images", event.target.files[0]);

//                                           addImageApi.mutate(formData, {
//                                             onSuccess: (response) => {
//                                               setFieldValue("image", response?.data[0]);
//                                             },
//                                             onError: (error) => {
//                                               ErrorToast(
//                                                 error?.response?.data?.message || "Server Error."
//                                               );
//                                             },
//                                           });
//                                         }
//                                       }}
//                                     />

//                                     <div className="user-information-button-handle ms-2">
//                                       <label className="user-information-change-profile-button d-block">
//                                         {values?.image === ""
//                                           ? "Add"
//                                           : "Change"}{" "}
//                                         image
//                                         <input
//                                           type="file"
//                                           multiple={false}
//                                           name="image"
//                                           accept="image/png, image/jpeg, image/jpg"
//                                           className="filetype d-none "
//                                           onChange={(event) => {
//                                             if (
//                                               event.target.files &&
//                                               event.target.files[0]
//                                             ) {
//                                               event.preventDefault();

//                                               const formData = new FormData();
//                                               formData.append(
//                                                 "images",
//                                                 event.target.files[0]
//                                               );

//                                               addImageApi.mutate(formData, {
//                                                 onSuccess: (response) => {
//                                                   setFieldValue(
//                                                     "image",
//                                                     response?.data[0]
//                                                   );
//                                                 },
//                                                 onError: (error) => {
//                                                   ErrorToast(
//                                                     error?.response?.data
//                                                       ?.message ||
//                                                       "Server error."
//                                                   );
//                                                 },
//                                               });
//                                             }
//                                           }}
//                                         />
//                                       </label>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                               <ErrorMessage
//                                 name="image"
//                                 component="div"
//                                 className="text-danger"
//                               />
//                             </div>
//                             <div className="col-md-6">
//                               <Field
//                                 Label="Name"
//                                 type="text"
//                                 name="name"
//                                 placeholder="Enter Emoji Name"
//                                 component={InputWithLabel}
//                               />
//                             </div>
//                           </div>
//                           <div className="text-end mt-5">
//                             <button
//                               type="submit"
//                               className="btn btn-them-gray btn"
//                             >
//                               <MdModeEditOutline className="me-1" size={20} />
//                               Edit Emoji
//                             </button>
//                           </div>
//                         </Form>
//                       );
//                     }}
//                   </Formik>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EditEmoji;

import { ErrorMessage, Field, Form, Formik } from "formik";
import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useQuery } from "@tanstack/react-query";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  EmojiIntialValues,
  EmojiValidationSchema,
} from "../../constant";
import {
  useMutateEditEmoji,
} from "../../hooks/useApiHook";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import InputWithLabel from "../../../../Components/InputWithLabel";
import "../../newstyle.css";
import DiscoverImageSelect from "../../../Discover/components/ImageUpload";
import { GetSingleEmoji } from "../../../../Api/emoji";
import BackButton from "../../../../Components/BackButton";
import SaveButton from "../../../../Components/SaveButton";

const EditEmoji = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const stateData = useLocation();
  const [isLoading, setIsLoading] = useState(false);



  const { id } = stateData?.state || "";




  const editEmojiApi = useMutateEditEmoji();

  const { data } = useQuery({
    queryKey: ["get-single-emoji"],
    queryFn: () => GetSingleEmoji(id),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  useEffect(() => {
    if (data) {
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          name: data?.data?.name,
          image: data?.data?.image_url,
        });
      }
    }
  }, [data]);

  function getLastNameFromUrl(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  const handleSubmitEditEmoji = (values) => {
    const reqData = {
      emojiId: id,
      name: values?.name,
      image: values?.image ? getLastNameFromUrl(values?.image) : "",
    };

    setIsLoading(true);
    editEmojiApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || "Product Updated.");
        navigate("/admin/emoji");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };

  return (
    <>
      <Helmet>
        <title>OVE | Admin Edit Emoji</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border overflow-visible">
                <div className="card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Edit Emoji</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/emoji" />
                      </div>
                    </div>
                  </div>

                  <Formik
                    initialValues={EmojiIntialValues}
                    validationSchema={EmojiValidationSchema}
                    validateOnChange
                    innerRef={formRef}
                    onSubmit={handleSubmitEditEmoji}
                  >
                    {(formik) => {
                      const { setFieldValue, values } = formik;
                      return (
                        <Form>
                          <section className="section-border">
                            <div className="row">
                              <div className="col-md-3">
                                <Field
                                  Label="Image"
                                  name="image"
                                  component={DiscoverImageSelect}
                                  useArrayForImageUrl={false}
                                  require={true}
                                />
                              </div>
                              <div className="col-md-9">
                                <Field
                                  Label="Name"
                                  type="text"
                                  name="name"
                                  placeholder="Enter Emoji Name"
                                  component={InputWithLabel}
                                />
                              </div>
                            </div>
                            <SaveButton loading={isLoading} />
                          </section>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditEmoji;